import React from 'react';
interface ProgressBarProps {
  progress: number;
}
export function ProgressBar({
  progress
}: ProgressBarProps) {
  return <div className="fixed top-0 left-0 right-0 h-1 z-50 bg-transparent" data-id="element-208">
      <div className="h-full bg-[#0EA5B7] transition-all duration-300 ease-out" style={{
      width: `${progress}%`
    }} role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100} data-id="element-209" />
    </div>;
}